import DvTextField from '@/packages/ui/components/inputs/DvTextField.vue';
import DvTextarea from '@/packages/ui/components/inputs/DvTextarea.vue';
import FileItemLoader from '@/packages/ui/components/files/FileItemLoader.vue';
import AutocompleteQuestionTags from '@/modules/UIDesign/Events/components/event-dashboard/dashboard-event-tasks/inputs/AutocompleteQuestionTags.vue';
import CheckboxResponseType from '@/modules/UIDesign/Events/components/event-dashboard/dashboard-event-tasks/inputs/CheckboxResponseType.vue';

import QuestionCriteriaForm from '@/modules/UIDesign/Events/components/event-dashboard/dashboard-event-tasks/forms/QuestionCriteriaForm.vue';
import QuestionOptionsForm from '@/modules/UIDesign/Events/components/event-dashboard/dashboard-event-tasks/forms/QuestionOptionsForm.vue';
import TextInputOptionsForm from '@/modules/UIDesign/Events/components/event-dashboard/dashboard-event-tasks/forms/TextInputOptionsForm.vue';
import ListSelectionOptionsForm from '@/modules/UIDesign/Events/components/event-dashboard/dashboard-event-tasks/forms/ListSelectionOptionsForm.vue';
import PairMatchOptionsForm from '@/modules/UIDesign/Events/components/event-dashboard/dashboard-event-tasks/forms/PairMatchOptionsForm.vue';

import { EXTENSIONS } from '@/constants/filesExtensions';

import constants from './constants';

const { QUESTION_TYPES } = constants;

const QUESTION_TYPES_COMMON_SCHEMAS = [
  {
    name: 'name',
    label: 'Текст вопроса',
    value: 'name',
    rules: 'required',
    component: DvTextField,
    props: {
      placeholder: 'Введите название',
    },
  },
  {
    name: 'description',
    label: 'Дополнительная информация',
    value: 'description',
    component: DvTextarea,
  },
  {
    name: 'image',
    label: 'Изображение к вопросу',
    value: 'image',
    component: FileItemLoader,
    props: {
      hidePrependIcon: true,
      accept: EXTENSIONS.images.accept,
      maxFileSizeInKb: '5120',
    },
  },
  {
    name: 'tag',
    label: 'Тег вопроса',
    value: 'tag.id',
    component: AutocompleteQuestionTags,
  },
];

const QUESTION_TYPES_FORMS = {
  criteria: {
    name: 'criterias',
    value: 'criterias',
    component: QuestionCriteriaForm,
  },
  options: (props = {}) => ({
    name: 'options',
    value: 'options',
    component: QuestionOptionsForm,
    props,
  }),
};

const QUESTION_TYPES_DATA = {
  [QUESTION_TYPES.text]: {
    id: QUESTION_TYPES.text,
    name: 'Текстовый',
    description: 'Развернутый письменный ответ',
    icon: '$ui-edit',
    calcMaxPoints: ({ criterias }) => criterias.reduce(
      (acc, i) => (acc + i.max_score), 0),
    schema: [
      ...QUESTION_TYPES_COMMON_SCHEMAS,
    ],
    forms: [
      QUESTION_TYPES_FORMS.criteria,
    ],
  },
  [QUESTION_TYPES.other]: {
    id: QUESTION_TYPES.other,
    name: 'Другое',
    description: 'Документ, изображение, ссылка',
    icon: '$ui-edit',
    calcMaxPoints: ({ criterias }) => criterias.reduce(
      (acc, i) => (acc + i.max_score), 0),
    schema: [
      {
        name: 'settings',
        value: 'settings',
        rules: 'required_select:1,some',
        component: CheckboxResponseType,
      },
      ...QUESTION_TYPES_COMMON_SCHEMAS,
    ],
    forms: [
      QUESTION_TYPES_FORMS.criteria,
    ],
  },
  [QUESTION_TYPES.textInputOption]: {
    id: QUESTION_TYPES.textInputOption,
    name: 'Ввод текста',
    icon: '$ui-list',
    calcMaxPoints: ({ options }) => options.reduce(
      (acc, i) => (acc + i.score), 0),
    schema: [
      ...QUESTION_TYPES_COMMON_SCHEMAS,
    ],
    forms: [
      QUESTION_TYPES_FORMS.options({
        component: TextInputOptionsForm,
        title: 'Варианты названия ответа',
      }),
    ],
  },
  [QUESTION_TYPES.listSelectionOption]: {
    id: QUESTION_TYPES.listSelectionOption,
    name: 'Выбор из списка',
    icon: '$ui-checklist',
    calcMaxPoints: ({ options }) => options.reduce(
      (acc, i) => {
        if (!i.is_correct) return acc;
        return acc + i.score;
      }, 0),
    schema: [
      ...QUESTION_TYPES_COMMON_SCHEMAS,
    ],
    forms: [
      QUESTION_TYPES_FORMS.options({
        component: ListSelectionOptionsForm,
      }),
    ],
  },
  [QUESTION_TYPES.pairMatchOption]: {
    id: QUESTION_TYPES.pairMatchOption,
    name: 'Сопоставление пар',
    icon: '$ui-route',
    calcMaxPoints: ({ options }) => options.reduce(
      (acc, i) => (acc + i.score), 0),
    schema: [
      ...QUESTION_TYPES_COMMON_SCHEMAS,
    ],
    forms: [
      QUESTION_TYPES_FORMS.options({
        component: PairMatchOptionsForm,
      }),
    ],
  },
};

const QUESTION_TYPES_LIST = Object.values(QUESTION_TYPES_DATA);

export default {
  QUESTION_TYPES_DATA,
  QUESTION_TYPES_LIST,
};
